import React from 'react';
import { CITIES } from '../data/smaken';

/** Stylised outline of Småland, drawn by hand rather than traced from a GIS file. */
export const SMALAND_PATH = 'M18 22c6-10 22-14 38-12 14 2 28 6 34 16 5 8 2 18-2 26-3 8-2 18-8 26-8 10-24 16-38 14-12-2-20-10-24-20-5-12-6-24-4-34Z';
interface MiniMapProps {
  city: string;
  accent?: string;
  className?: string;
}

/** A single-pin map used on a business profile. */
export function MiniMap({
  city,
  accent = '#E42616',
  className = ''
}: MiniMapProps) {
  const pos = CITIES[city as keyof typeof CITIES];
  return <svg viewBox="0 0 100 100" className={className} role="img" aria-label={`Karta: ${city}, Småland`} data-id="element-749" data-mp="39z8edzmulrem">
      <path d={SMALAND_PATH} fill="#EDE6DA" stroke="#111111" strokeWidth="0.6" strokeLinejoin="round" data-id="element-750" data-mp="30w7a84hjmadl" />
      {pos && <>
          <circle cx={pos.x} cy={pos.y} r="4.5" fill={accent} opacity="0.2" data-id="element-751" data-mp="144714pofcjw9" />
          <circle cx={pos.x} cy={pos.y} r="2" fill={accent} stroke="#F7F3EC" strokeWidth="0.5" data-id="element-752" data-mp="z540dhfh8zu3" />
          <text x={pos.x} y={pos.y - 5} textAnchor="middle" style={{
        font: '600 3.5px Inter, sans-serif',
        fill: '#111111'
      }} data-id="element-753" data-mp="1z2zbq056tamh">
            {city}
          </text>
        </>}
    </svg>;
}